import { ObjectList } from "web/components"
import {
  useDealComparablesView,
  useRemoveDealComparableDeals,
} from "web/hooks/data"

import { useCurrentTLO } from "web/hooks/context"
import { NavigationProvider } from "web/contexts"

import FindComparablesButton from "../shared/FindComparablesButton"

import { TrashIcon } from "@heroicons/react/24/outline"

export default function SavedComparableDeals({ baseUrl }) {
  const { userCan, data: deal } = useCurrentTLO()

  const removeComparableDeals = useRemoveDealComparableDeals({ deal })

  const [viewGroup] = useDealComparablesView(deal)

  function goToComparableDeal(sale) {
    window.Turbo.visit(`/markets/global/sales/view/${sale.id}`)
  }

  async function handleRemoveDealComparableDeal({ all, selected }) {
    await removeComparableDeals(selected)
    all.refresh()
  }

  const selectedItemActions = []
  if (userCan("update")) {
    selectedItemActions.push({
      label: "Remove",
      icon: TrashIcon,
      action: handleRemoveDealComparableDeal,
    })
  }

  return (
    <NavigationProvider viewGroup={viewGroup} viewId={null}>
      <div className="-mx-3 flex min-h-0 grow flex-col lg:-mx-5">
        <ObjectList
          subjectType="sale"
          parentSubjectType="deal"
          parentSubjectId={deal.id}
          exportPath={`/deals/${deal.id}/sales`}
          listType="deal_comparable_deals"
          availableViews={["table", "cards", "map", "compare"]}
          defaultView="cards"
          onItemClick={goToComparableDeal}
          selectedItemActions={selectedItemActions}
          enableLocationIndex
          rootUrl={baseUrl}
          canRedirectToRootUrl={false}
          customListActions={<FindComparablesButton baseURL={baseUrl} />}
        />
      </div>
    </NavigationProvider>
  )
}
